import { COPAY_PERMISSION } from '@/core/entities/interfaces/permissions';
import { PROCEDURE_TARGET_EDITION } from '@/modules/copay/entities/enums/procedures';
import { USAGE_STATEMENT_STATUS_FULL } from '@/modules/copay/entities/enums/usageStatement';
import { UsageStatementProcess } from '@/modules/copay/entities/interfaces/usageStatements';
import { getUnauthorizedMessage } from '@/modules/copay/utils/messages';
import useCurrentUser from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';

interface UseCopayPemissionsProps {
  usageStatementProcess?: UsageStatementProcess;
  target?: PROCEDURE_TARGET_EDITION;
}

export const useCopayPermissions = ({
  usageStatementProcess,
  target = PROCEDURE_TARGET_EDITION.DESCRIPTION,
}: UseCopayPemissionsProps) => {
  const { checkUserHasPermission } = useCurrentUser();

  if (usageStatementProcess?.status === USAGE_STATEMENT_STATUS_FULL.FINISHED) {
    return {
      canAddProcedureData: false,
      canUpdateProcedureData: false,
      canAct: false,
      unauthorizedMessage: getUnauthorizedMessage(usageStatementProcess, target),
    };
  }

  let permissionToAdd = COPAY_PERMISSION.COPAY_PROCEDURE_ADD_DESCRIPTION;
  let permissionToUpdate = COPAY_PERMISSION.COPAY_PROCEDURE_UPDATE_DESCRIPTION;
  let alreadyAdded = Boolean(usageStatementProcess?.descriptionAddedAt);
  let canAddProcedureData = checkUserHasPermission(permissionToAdd);

  if (target === PROCEDURE_TARGET_EDITION.LABEL) {
    permissionToAdd = COPAY_PERMISSION.COPAY_PROCEDURE_ADD_LABEL;
    permissionToUpdate = COPAY_PERMISSION.COPAY_PROCEDURE_UPDATE_LABEL;
    alreadyAdded = Boolean(usageStatementProcess?.labelAddedAt);
    canAddProcedureData =
      Boolean(usageStatementProcess?.descriptionAddedAt) && checkUserHasPermission(permissionToAdd);
  }

  const canUpdateProcedureData = checkUserHasPermission(permissionToUpdate);
  const canAct = alreadyAdded ? canUpdateProcedureData : canAddProcedureData;

  return {
    canAddProcedureData,
    canUpdateProcedureData,
    canAct,
    unauthorizedMessage: getUnauthorizedMessage(usageStatementProcess, target),
  };
};
